import { fetchApp, selectAppById } from "@app/deploy";
import { fetchEdges, selectEdgeDependenciesByType } from "@app/deploy/edge";
import { useQuery, useSelector } from "@app/react";
import { useParams } from "react-router";
import {
  AppDependencyList,
  Banner,
  DatabaseDependencyList,
  Group,
  PermissionGate,
  tokens,
} from "../shared";

export const AppDetailDepsPage = () => {
  const { id = "" } = useParams();
  useQuery(fetchApp({ id }));
  const app = useSelector((s) => selectAppById(s, { id }));
  useQuery(
    fetchEdges({
      rootResourceId: id,
      rootResourceType: "App",
      maxDistance: 1,
      onlyRelationshipTypes: ["depends_on"],
    }),
  );
  const depGroups = useSelector((s) =>
    selectEdgeDependenciesByType(s, { id: app.id }),
  );

  return (
    <PermissionGate scope="read" envId={app.environmentId}>
      <Group>
        <Banner variant="info">
          Dependencies are connections tracked by the Aptible platform based on
          resource relationships.
        </Banner>
        <h3 className={tokens.type.h3}>Databases</h3>
        <DatabaseDependencyList databases={depGroups.database} />
        <h3 className={tokens.type.h3}>Apps</h3>
        <AppDependencyList apps={depGroups.app} />
      </Group>
    </PermissionGate>
  );
};
